<ul class="context-menu">
  @for (option of actions(); track $index) {
    <li (click)="actionClicked(option.action)">
      {{ option.label }}
    </li>
  }

</ul>
